import { Component, HostListener, OnInit, signal } from '@angular/core';

import { AbstractGridComponent } from '../abstract-grid.component';

@Component({
  selector: 'cam-grid-expandable',
  styleUrl: './grid-expandable.component.scss',
  templateUrl: './grid-expandable.component.html',
})
export class GridExpandableComponent extends AbstractGridComponent<any> implements OnInit {
  readonly isExpanded = signal(false);

  public override ngOnInit() {
    super.ngOnInit();
    this.isExpanded.set(this._grid.expanded);
    this._registerSubscription(this._grid.expandedChanged$.subscribe(value => this.isExpanded.set(value)));
  }

  public collapse() {
    this._grid.toggleExpanded(false);
  }

  @HostListener('document:keydown.escape')
  public onEscape() {
    if (this.isExpanded()) {
      this.collapse();
    }
  }
}
